import { useEffect, useState } from 'react';
var useCookieConsent = function (category) {
    var _a;
    var _b = useState(((_a = global.OnetrustActiveGroups) === null || _a === void 0 ? void 0 : _a.split(',').filter(function (c) { return c.length; })) || []), allowedCategories = _b[0], setAllowedCategories = _b[1];
    var cookieExist = false;
    // First check if Cookie exist
    try {
        var categoryNumber = category.split('C000')[1];
        if (typeof window !== 'undefined' &&
            document.cookie.includes("cookiesAccepted" + categoryNumber + "=true")) {
            cookieExist = true;
        }
    }
    catch (error) {
        // error
    }
    // If not then useEffect with CustomEvent Listener
    useEffect(function () {
        if (typeof window !== 'undefined' && !cookieExist) {
            var onChange_1 = function (_a) {
                var _b = _a.detail, detail = _b === void 0 ? [] : _b;
                return setAllowedCategories(detail);
            };
            window.addEventListener('consent.onetrust', onChange_1);
            return function () { return window.removeEventListener('consent.onetrust', onChange_1); };
        }
        return function () { };
    });
    return cookieExist || allowedCategories.includes(category);
};
export default useCookieConsent;
//# sourceMappingURL=index.js.map